import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NavbarWrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333;
  padding: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;  // Adjust this to fit your needs
  z-index: 1000; // High z-index to make sure navbar is always on top
`;

const NavbarList = styled.ul`
  display: flex;
  gap: 1rem;
  list-style-type: none;
`;

const NavbarLink = styled(Link)`
  color: #fff;
  text-decoration: none;

  &:hover {
    color: #ddd;
  }
`;

const Navbar = () => {
  return (
    <NavbarWrapper>
      {/* <NavbarLink to="/">Logo</NavbarLink> */}
      <NavbarList>
        <li>
          <NavbarLink to="/home">Home</NavbarLink>
        </li>
        <li>
          <NavbarLink to="/rate">Rate Player</NavbarLink>
        </li>
        <li>
          <NavbarLink to="/quickgame">Quick Game</NavbarLink>
        </li>
        {/* Add more links as needed */}
      </NavbarList>
    </NavbarWrapper>
  );
}

export default Navbar;
